/* STIGA Pickleball — section behaviors.
   Deliberately independent of theme JS except where it feeds it:
   the PDP updates the hidden `.product-variant-id` input inside the
   theme's <product-form>, so the existing AJAX add-to-cart and
   minicart keep working untouched. */
(function () {
  'use strict';

  /* Mobile nav toggle */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-stiga-burger]');
    if (burger) {
      var header = burger.closest('.stiga-header');
      var open = header.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  /* PDP: variant selection, price, gallery, quantity */
  function initPdp(root) {
    var dataEl = root.querySelector('[data-stiga-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-stiga-option]'));
    var idInput = root.querySelector('.product-variant-id');
    var priceEl = root.querySelector('[data-stiga-price]');
    var buyBtn = root.querySelector('[data-stiga-add]');

    function currentVariant() {
      var chosen = selects.map(function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function onChange() {
      var v = currentVariant();
      if (!v) return;
      if (idInput) { idInput.value = v.id; idInput.disabled = false; }
      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price > v.price
          ? v.price_formatted + ' <s>' + v.compare_at_price_formatted + '</s>'
          : v.price_formatted;
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        var label = buyBtn.querySelector('span');
        if (label) label.textContent = v.available ? buyBtn.dataset.labelAdd : buyBtn.dataset.labelSoldOut;
      }
      if (v.featured_media_position) {
        var thumb = root.querySelector('[data-stiga-thumb][data-position="' + v.featured_media_position + '"]');
        if (thumb) thumb.click();
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', onChange); });

    /* Gallery thumbs */
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-stiga-thumb]');
      if (!thumb) return;
      var main = root.querySelector('[data-stiga-main-image]');
      if (main) {
        main.src = thumb.dataset.full;
        main.srcset = '';
        main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
      }
      root.querySelectorAll('[data-stiga-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });

    /* Quantity stepper */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-stiga-qty]');
      if (!btn) return;
      var input = root.querySelector('input[name="quantity"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val += btn.dataset.stigaQty === 'plus' ? 1 : -1;
      input.value = Math.max(1, val);
    });
  }

  function boot() {
    document.querySelectorAll('[data-stiga-pdp]').forEach(initPdp);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

/* Showcase gallery (arrow nav + 01/06 counter) and paddle finder */
(function () {
  'use strict';
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initGallery(root) {
    var dataEl = root.querySelector('[data-stiga-gallery-data]');
    if (!dataEl) return;
    var urls;
    try { urls = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var i = 0;
    var img = root.querySelector('[data-stiga-gallery-image]');
    var idx = root.querySelector('[data-stiga-gallery-index]');
    function show(n) {
      i = (n + urls.length) % urls.length;
      if (img) { img.src = urls[i]; img.srcset = ''; }
      if (idx) idx.textContent = pad(i + 1);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-stiga-gallery-prev]')) show(i - 1);
      if (e.target.closest('[data-stiga-gallery-next]')) show(i + 1);
    });
  }

  function initFinder(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-stiga-finder-choice]');
      if (!btn) return;
      var n = btn.getAttribute('data-stiga-finder-choice');
      root.querySelectorAll('[data-stiga-finder-choice]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      root.querySelectorAll('[data-stiga-finder-result]').forEach(function (r) {
        r.classList.toggle('is-active', r.getAttribute('data-stiga-finder-result') === n);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-stiga-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-stiga-finder]').forEach(initFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Approved STIGA concept landing page interactions */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initReferenceGallery(root) {
    if (root.dataset.stigaRefGalleryReady === 'true') return;
    root.dataset.stigaRefGalleryReady = 'true';

    var main = root.querySelector('[data-stiga-ref-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-stiga-ref-thumb]'));
    var index = root.querySelector('[data-stiga-ref-gallery-index]');
    if (!main || !thumbs.length) return;

    var current = Math.max(0, thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); }));

    function show(next) {
      current = (next + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      var src = thumb.getAttribute('data-src');
      if (src) {
        main.src = src;
        main.srcset = '';
      }
      thumbs.forEach(function (item, i) {
        item.classList.toggle('is-active', i === current);
        item.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
      if (index) index.textContent = pad(current + 1);
    }

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-stiga-ref-thumb]');
      if (thumb && root.contains(thumb)) {
        show(thumbs.indexOf(thumb));
        return;
      }
      if (event.target.closest('[data-stiga-ref-gallery-prev]')) show(current - 1);
      if (event.target.closest('[data-stiga-ref-gallery-next]')) show(current + 1);
    });

    show(current);
  }

  function initReferenceTabs(root) {
    if (root.dataset.stigaRefTabsReady === 'true') return;
    root.dataset.stigaRefTabsReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-stiga-ref-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-stiga-ref-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(name) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-stiga-ref-tab') === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-stiga-ref-panel') === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-stiga-ref-tab]');
      if (tab) activate(tab.getAttribute('data-stiga-ref-tab'));
    });
    activate((tabs.find(function (tab) { return tab.classList.contains('is-active'); }) || tabs[0]).getAttribute('data-stiga-ref-tab'));
  }

  function initConstruction(root) {
    if (root.dataset.stigaRefConstructionReady === 'true') return;
    root.dataset.stigaRefConstructionReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-stiga-ref-construction-tab]'));
    if (!tabs.length) return;

    var image = root.querySelector('[data-stiga-ref-construction-image]');
    var family = root.querySelector('[data-stiga-ref-construction-family]');
    var name = root.querySelector('[data-stiga-ref-construction-name]');
    var description = root.querySelector('[data-stiga-ref-construction-description]');
    var face = root.querySelector('[data-layer-face]');
    var core = root.querySelector('[data-layer-core]');
    var perimeter = root.querySelector('[data-layer-perimeter]');
    var geometry = root.querySelector('[data-layer-geometry]');

    function activate(tab) {
      tabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (image && tab.dataset.image) {
        image.src = tab.dataset.image;
        image.srcset = '';
        image.alt = tab.dataset.name + ' construction detail';
      }
      if (family) family.textContent = tab.dataset.family || '';
      if (name) name.textContent = tab.dataset.name || '';
      if (description) description.textContent = tab.dataset.description || '';
      if (face) face.textContent = tab.dataset.face || '';
      if (core) core.textContent = tab.dataset.core || '';
      if (perimeter) perimeter.textContent = tab.dataset.perimeter || '';
      if (geometry) geometry.textContent = tab.dataset.geometry || '';
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-stiga-ref-construction-tab]');
      if (tab) activate(tab);
    });
    activate(tabs.find(function (tab) { return tab.classList.contains('is-active'); }) || tabs[0]);
  }

  function initReferenceFinder(root) {
    if (root.dataset.stigaRefFinderReady === 'true') return;
    root.dataset.stigaRefFinderReady = 'true';
    var choices = Array.prototype.slice.call(root.querySelectorAll('[data-stiga-ref-finder-choice]'));
    var image = root.querySelector('[data-stiga-ref-finder-image]');
    var name = root.querySelector('[data-stiga-ref-finder-name]');
    var tagline = root.querySelector('[data-stiga-ref-finder-tagline]');
    var link = root.querySelector('[data-stiga-ref-finder-link]');
    if (!choices.length) return;

    function activate(choice) {
      choices.forEach(function (item) {
        var active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (image && choice.dataset.image) {
        image.src = choice.dataset.image;
        image.srcset = '';
        image.alt = choice.dataset.name || 'STIGA paddle';
      }
      if (name) name.textContent = choice.dataset.name || '';
      if (tagline) tagline.textContent = choice.dataset.tagline || '';
      if (link && choice.dataset.link) link.href = choice.dataset.link;
    }

    root.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-stiga-ref-finder-choice]');
      if (choice) activate(choice);
    });
    activate(choices.find(function (choice) { return choice.classList.contains('is-active'); }) || choices[0]);
  }

  function initReveals(scope) {
    var elements = Array.prototype.slice.call(scope.querySelectorAll('.stiga-ref-reveal:not([data-stiga-ref-reveal-ready])'));
    if (!elements.length) return;
    elements.forEach(function (el) { el.setAttribute('data-stiga-ref-reveal-ready', 'true'); });

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    elements.forEach(function (el) { observer.observe(el); });
  }

  function bootReferencePage(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-stiga-ref-gallery]').forEach(initReferenceGallery);
    scope.querySelectorAll('[data-stiga-ref-tabs]').forEach(initReferenceTabs);
    scope.querySelectorAll('[data-stiga-ref-construction]').forEach(initConstruction);
    scope.querySelectorAll('[data-stiga-ref-finder]').forEach(initReferenceFinder);
    initReveals(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootReferencePage(document); });
  } else {
    bootReferencePage(document);
  }
  document.addEventListener('shopify:section:load', function (event) { bootReferencePage(event.target); });
})();
/* Keep shared products in the pickleball context:
   product links on STIGA pages carry ?view=pickleball-product */
(function () {
  function tag(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.origin);
      if (u.origin !== location.origin) return;
      if (u.pathname.indexOf('/products/') === -1) return;
      if (u.searchParams.has('view')) return;
      u.searchParams.set('view', 'pickleball-product');
      a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href*="/products/"]').forEach(tag);
  });
  /* catches links injected later (recommendations, quickview, search) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (a) tag(a);
  }, true);
})();
/* STIGA pages send customers to the pickleball-branded cart */
(function () {
  function tagCart(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.origin);
      if (u.origin !== location.origin) return;
      if (u.pathname !== '/cart' && u.pathname !== '/cart/') return;
      if (u.searchParams.has('view')) return;
      u.searchParams.set('view', 'pickleball');
      a.setAttribute('href', u.pathname + u.search);
    } catch (e) {}
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href*="/cart"]').forEach(tagCart);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/cart"]');
    if (a) tagCart(a);
  }, true);
})();
/* STIGA homepage URL: the root of www.stigapickleball.us; on any other host (theme editor,
   paddlepalace.com) it is still the page template. Shared by the fixes below. */
var STIGA_HOME = /stigapickleball/.test(location.hostname) ? '/' : '/pages/stiga-pickleball';
/* Pickleball cart: empty-state "Continue Shopping" goes to the STIGA homepage */
(function () {
  function fix() {
    document.querySelectorAll('#main-cart-items .cart__warnings a[href="/"]')
      .forEach(function (a) { a.setAttribute('href', STIGA_HOME); });
  }
  document.addEventListener('DOMContentLoaded', fix);
  /* cart re-renders after AJAX updates (e.g. removing the last item) — catch the injected button too */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#main-cart-items .cart__warnings a[href="/"]');
    if (a) a.setAttribute('href', STIGA_HOME);
  }, true);
})();
/* STIGA pages use the pickleball-branded compare page (same compare engine,
   ?view=stiga-compare template). Milano's <button-compare data-action="go_to_page">
   navigates to /pages/compare from theme.js once the product is in the list, so
   intercept that click and take over the navigation; also tag plain links. */
(function () {
  var COMPARE_URL = '/pages/compare?view=stiga-compare';
  function tagCompare(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.origin);
      if (u.origin !== location.origin) return;
      if (u.pathname !== '/pages/compare' && u.pathname !== '/pages/compare/') return;
      if (u.searchParams.has('view')) return;
      u.searchParams.set('view', 'stiga-compare');
      a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href*="/pages/compare"]').forEach(tagCompare);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/pages/compare"]');
    if (a) tagCompare(a);
    var btn = e.target.closest && e.target.closest('button-compare');
    if (btn && btn.getAttribute('data-action') === 'go_to_page' && inCompareList(btn.getAttribute('data-product-id'))) {
      /* already added: the theme would navigate to /pages/compare - go to the STIGA view instead.
         First click (not yet in the list) is left to the theme so it adds the product. */
      e.preventDefault();
      e.stopImmediatePropagation();
      location.href = COMPARE_URL;
    }
  }, true);
  function inCompareList(id) {
    if (!id) return false;
    try {
      var list = JSON.parse(localStorage.getItem('milano__compare-items')) || [];
      return list.some(function (x) { return String(x) === String(id); });
    } catch (err) { return false; }
  }
})();
/* STIGA compare view (any page rendered with ?view=stiga-compare): empty-state
   "Back To Shopping" goes to the STIGA homepage instead of /collections/all */
(function () {
  function fix() {
    document.querySelectorAll('.compare-no-product-url')
      .forEach(function (a) { a.setAttribute('href', STIGA_HOME); });
  }
  document.addEventListener('DOMContentLoaded', fix);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.compare-no-product-url');
    if (a) a.setAttribute('href', STIGA_HOME);
  }, true);
})();
/* STIGA login. Shopify's account_login_url renders as a direct link to the account hub
   (account.paddlepalace.com), which signs the customer in on paddlepalace.com only; the
   STIGA domain never gets a session, so wholesale pricing never shows here. Send Log In
   links through this storefront's own login endpoint instead: the hub returns the customer
   to the page they were on, signed in on stigapickleball.us. Only the hub's root URL is
   rewritten (Log In / Register); logout and account links are left alone. */
(function () {
  var HUB = /^https?:\/\/account\.paddlepalace\.com\/?(\?|$)/i;
  function fix(a) {
    if (HUB.test(a.getAttribute('href') || '')) {
      a.setAttribute('href', '/customer_authentication/login?return_url=' +
        encodeURIComponent(location.pathname + location.search));
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href]').forEach(fix);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a) fix(a);
  }, true);
})();